<section
  *transloco="let t"
  class="sign-in-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect"
  [class.dialog]="inDialog"
  [class.small-mobileL]="(lessThan$ | async)?.mobileL"
  [class.small-xs]="(lessThan$ | async)?.xs">
  <nav class="dialog-head" *ngIf="inDialog">
    <button
      class="popsy-button-icon button"
      [class.rtl]="isRtlLayout$ | async"
      *ngIf="previousMode === 'auth-intro' || previousMode === 'sign-up'"
      (click)="
        changeDialogMode(previousMode === 'auth-intro' ? 'auth-intro' : 'sign-up')
      ">
      <popsy-icon-arrow-left-1
        class="icon gray-dark"
        aria-hidden="true"></popsy-icon-arrow-left-1>
    </button>
    <div aria-hidden="true" class="dynamic-space"></div>
    <button class="popsy-button-icon button small" (click)="close(true)">
      <popsy-icon-remove class="icon gray-dark" aria-hidden="true"></popsy-icon-remove>
    </button>
  </nav>
  <form class="form" name="sign-in" (ngSubmit)="signIn()" [formGroup]="signInForm">
    <h2 class="title">{{ t('title_sign_in') }}</h2>
    <h3 class="subtitle">{{ t('subtitle_sign_in') }}</h3>
    <div class="form-field" floatLabel="always" shouldLabelFloat hideRequiredMarker>
      <div class="label">{{ t('hint_email') }}</div>
      <input
        data-clarity-unmask
        #email
        type="email"
        class="field"
        [formControl]="this.emailFormControl"
        inputmode="email"
        name="email"
        autocomplete="email"
        required />
      <span class="error" *ngIf="this.emailFormControl.hasError('required') && submitted">
        {{ t('error_email_required') }}
      </span>
      <span class="error" *ngIf="this.emailFormControl.hasError('email')">
        {{ t('error_email_not_valid') }}
      </span>
      <span class="error" *ngIf="this.emailFormControl.hasError('USER_NOT_FOUND')">
        {{ t('error_login_does_not_exist') }}
      </span>
      <span class="error" *ngIf="this.emailFormControl.hasError('USER_BANNED')">
        {{ t('error_login_does_not_exist') }}
      </span>
    </div>

    <div
      class="form-field"
      [class.rtl]="isRtlLayout$ | async"
      floatLabel="always"
      shouldLabelFloat
      hideRequiredMarker>
      <div class="label">{{ t('hint_password') }}</div>
      <input
        data-clarity-unmask
        #password
        matInput
        class="field password"
        [type]="hidePassword ? 'password' : 'text'"
        [formControl]="passwordFormControl"
        autocomplete="password"
        required />
      <div class="button-wrap">
        <button
          type="button"
          (click)="togglePassword($event)"
          [attr.aria-label]="
            t(hidePassword ? 'action_hide_password' : 'action_show_password')
          "
          [attr.aria-pressed]="hidePassword">
          <ng-container *ngIf="!hidePassword">
            <popsy-icon-view-off
              class="icon gray-02"
              aria-hidden="true"></popsy-icon-view-off>
          </ng-container>
          <ng-container *ngIf="hidePassword">
            <popsy-icon-view-1
              class="icon gray-02"
              aria-hidden="true"></popsy-icon-view-1>
          </ng-container>
        </button>
      </div>

      <span
        class="error"
        *ngIf="signInForm.controls['password'].hasError('required') && submitted">
        {{ t('error_password_required') }}
      </span>
      <span class="error" *ngIf="signInForm.controls['password'].hasError('minlength')">
        {{ t('error_password_too_short', { var1: 6 }) }}
      </span>
      <span
        class="error"
        *ngIf="signInForm.controls['password'].hasError('INVALID_CREDENTIALS')">
        {{ t('error_login_wrong_password') }}
      </span>
      <span class="error" *ngIf="signInForm.controls['password'].hasError('UNKNOWN')">
        {{ t('error_login_unknown') }}
      </span>
    </div>
    <div aria-hidden="true" class="dynamic-space"></div>
    <button
      type="submit"
      class="button popsy-button-primary"
      [class.error]="submitted && failed"
      [class.success]="submitted && success"
      (click)="signIn()">
      <app-loading class="spinner" *ngIf="loading"></app-loading>
      <span *ngIf="!loading" class="message">{{ t('title_login') }}</span>
    </button>

    <div class="link-area" *ngIf="!inDialog">
      <a
        href=""
        [routerLink]="authUrlFragment('sign-up')"
        [queryParams]="signUpQueryParams"
        (click)="stopPropagation()"
        >{{ t('action_create_account') }}</a
      >
      <span class="separation" *ngIf="!(lessThan$ | async)?.mobileL">{{ '|' }}</span>
      <a
        href=""
        [routerLink]="authUrlFragment('reset-password')"
        [queryParams]="signUpQueryParams"
        (click)="stopPropagation()"
        >{{ t('action_forgot') }}</a
      >
    </div>
    <div class="link-area" *ngIf="inDialog">
      <p (click)="changeDialogMode('sign-up')">{{ t('action_create_account') }}</p>
      <span class="separation" *ngIf="!(lessThan$ | async)?.mobileL">{{ '|' }}</span>
      <p (click)="changeDialogMode('reset-password')">{{ t('action_forgot') }}</p>
    </div>
  </form>
</section>
